import {Carousel} from '@shopify/marketing-assets';

import '../../application';

document.addEventListener('DOMContentLoaded', () => {
  new Carousel(document.querySelector('.case-study-carousel'));
});
